import { motion } from "framer-motion";
import { MailCheck, Phone } from "lucide-react";
import { DEALER } from "@/data/dealer";

export const DemoSent = ({ mode, prefix, onReset }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    className="rounded-lg border border-line bg-paper p-6 sm:p-8"
    role="status"
    aria-live="polite"
    data-testid={`${prefix}-demo-success`}
  >
    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-ink text-white" aria-hidden="true">
      <MailCheck className="h-6 w-6" />
    </span>
    <h3 className="mt-5 font-display text-2xl font-extrabold">{mode === "viewing" ? "Viewing request sent." : "Thanks — your enquiry has been sent."}</h3>
    <p className="mt-3 leading-relaxed text-steel">
      {mode === "viewing"
        ? "YK Motors will be in touch to confirm a time — your viewing isn't booked until they do."
        : "YK Motors will get back to you shortly."}{" "}
      If it's urgent, call {DEALER.phone.display}.
    </p>
    <div className="mt-6 flex flex-col gap-3 sm:flex-row">
      <a href={DEALER.phone.href} className="btn btn-primary" data-testid={`${prefix}-demo-call-link`}>
        <Phone aria-hidden="true" /> Call {DEALER.phone.display}
      </a>
      <button type="button" onClick={onReset} className="btn btn-outline" data-testid={`${prefix}-demo-reset-button`}>
        Send another message
      </button>
    </div>
  </motion.div>
);
